import React from "react";

function Header({ isPublic }) {
  return (
    <header id="header" className="header fixed-top d-flex align-items-center">
      <div className="d-flex align-items-center justify-content-between">
        <a className="logo d-flex align-items-center" href="/admin/dtdc_courier">
          <img src="/assets/img/bilipatra_logo.png" alt="" />
          <span className="d-none d-lg-block">BILIPATRA</span>
        </a>
        {!isPublic && <i className="bi bi-list toggle-sidebar-btn"></i>}
      </div>
      {/* End logo */}
      <nav className="header-nav ms-auto"></nav> {/* End Icons Navigation*/}
    </header>
  );
}

export default Header;
